const KOREA_TIME_ZONE = "Asia/Seoul";

const pad2 = (value) => String(value).padStart(2, "0");

export const normalizeAttendanceRows = (payload) => {
  const data = payload?.data || payload;

  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.rows)) return data.rows;
  if (Array.isArray(data?.items)) return data.items;
  if (Array.isArray(data?.list)) return data.list;
  if (Array.isArray(data?.results)) return data.results;
  if (Array.isArray(data?.data)) return data.data;

  return [];
};

const parseDateOnlyKey = (value) => {
  if (typeof value !== "string") return "";
  const match = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
  return match ? `${match[1]}-${match[2]}-${match[3]}` : "";
};

export const getKoreanDateKey = (value = new Date()) => {
  if (!value) return "";

  const dateOnlyKey = parseDateOnlyKey(value);
  if (dateOnlyKey) return dateOnlyKey;

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "";

  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: KOREA_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);

  const map = parts.reduce((acc, part) => {
    acc[part.type] = part.value;
    return acc;
  }, {});

  return `${map.year}-${map.month}-${map.day}`;
};

export const getAttendanceRowDateKey = (row = {}) =>
  getKoreanDateKey(
    row.attendance_date ||
      row.attandance_date ||
      row.attended_at ||
      row.current_date_time ||
      row.created_at ||
      row.date ||
      row.updated_at
  );

export const buildMonthCalendarDays = (monthDate = new Date()) => {
  const year = monthDate.getFullYear();
  const month = monthDate.getMonth();
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);
  const leadingEmptyCount = firstDay.getDay();
  const days = [];

  for (let index = 0; index < leadingEmptyCount; index += 1) {
    days.push({ key: `empty-start-${index}`, isEmpty: true });
  }

  for (let day = 1; day <= lastDay.getDate(); day += 1) {
    const date = new Date(year, month, day);
    const key = `${year}-${pad2(month + 1)}-${pad2(day)}`;
    days.push({ key, day, date, isEmpty: false });
  }

  while (days.length % 7 !== 0) {
    days.push({ key: `empty-end-${days.length}`, isEmpty: true });
  }

  return days;
};

export const formatMonthLabel = (value = new Date()) =>
  new Intl.DateTimeFormat("ko-KR", {
    timeZone: KOREA_TIME_ZONE,
    year: "numeric",
    month: "long",
  }).format(value);

export const formatRecentAttendanceDate = (value) => {
  const key = getKoreanDateKey(value);
  if (!key) return "-";
  const [year, month, day] = key.split("-");
  return `${year}.${month}.${day}`;
};

export const getAttendanceResultMessage = (result) =>
  result?.message || result?.data?.message || result?.error || result?.data?.error || "";
